export function obtenerMonedaTienda(configuracionTienda) {
    return {
      codigo: configuracionTienda?.moneda_codigo ?? "",
      simbolo: configuracionTienda?.moneda_simbolo ?? "",
    };
  }
  
  export function formatearPrecio(valor, configuracionTienda, opciones = {}) {
    if (valor === null || valor === undefined) {
      return "";
    }
    if (typeof valor === "string" && valor.trim() === "") {
      return "";
    }

    const numero = Number(valor);

    if (!Number.isFinite(numero)) {
      return "";
    }
  
    const {
      locale = "en-US",
      minimumFractionDigits = 2,
      maximumFractionDigits = 2,
      espacioEntreSimbolo = false,
    } = opciones;
  
    const { simbolo } = obtenerMonedaTienda(configuracionTienda);
  
    const numeroFormateado = numero.toLocaleString(locale, {
      minimumFractionDigits,
      maximumFractionDigits,
    });
  
    if (!simbolo) {
      return numeroFormateado;
    }
  
    return espacioEntreSimbolo
      ? `${simbolo} ${numeroFormateado}`
      : `${simbolo}${numeroFormateado}`;
  }

/**
 * Formato con código ISO 4217 (Intl) cuando no hay objeto tienda_configuracion:
 * pedidos con `moneda`, Stripe, listados de cliente, etc.
 */
export function formatearPrecioPorCodigoMoneda(
  valor,
  monedaCodigo = "GTQ",
  opciones = {}
) {
  const {
    locale = "es-GT",
    minimumFractionDigits = 2,
    maximumFractionDigits = 2,
  } = opciones;

  if (valor === null || valor === undefined) {
    return "";
  }
  if (typeof valor === "string" && valor.trim() === "") {
    return "";
  }

  const numero = Number(valor);
  if (!Number.isFinite(numero)) {
    return "";
  }

  const code = String(monedaCodigo || "GTQ").trim().toUpperCase() || "GTQ";

  try {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: code,
      minimumFractionDigits,
      maximumFractionDigits,
    }).format(numero);
  } catch {
    const numeroFormateado = numero.toLocaleString(locale, {
      minimumFractionDigits,
      maximumFractionDigits,
    });
    return `${code} ${numeroFormateado}`;
  }
}